import { h, Component } from 'preact';
// import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/sidePanel/loadIcon.sss';

export default class LoadIcon extends Component {

	render({ class: className }) {
		return <div class={joinClasses(s.loadingIcon, className)} />;
	}
}
